import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import { SxProps, Theme } from '@mui/material';

export const sort: {
	mainContainer: SxProps<Theme>;
} = {
	mainContainer: (theme) => ({
		maxWidth: '230px !important',
		minWidth: '230px',
		mx: 0,
		px: 0,
		[theme.breakpoints.down(DESKTOP_MIN_WIDTH - 1)]: {
			width: '100%',
			minWidth: 'unset',
			maxWidth: '100% !important',
		},
	}),
};
